import { render, staticRenderFns } from "./Avatar2.vue?vue&type=template&id=5a4d5da2&scoped=true&"
import script from "./Avatar2.vue?vue&type=script&lang=js&"
export * from "./Avatar2.vue?vue&type=script&lang=js&"
import style0 from "./Avatar2.vue?vue&type=style&index=0&id=5a4d5da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4d5da2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4d5da2')) {
      api.createRecord('5a4d5da2', component.options)
    } else {
      api.reload('5a4d5da2', component.options)
    }
    module.hot.accept("./Avatar2.vue?vue&type=template&id=5a4d5da2&scoped=true&", function () {
      api.rerender('5a4d5da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Layout/Avatar2.vue"
export default component.exports